// extracted by mini-css-extract-plugin
module.exports = {"comingSoon":"ComingSoon-module--comingSoon--2yaC2","background":"ComingSoon-module--background--3cKAf"};